import styled from 'styled-components';

const MainGrid = styled.div`
  display: grid;
  grid-auto-rows: auto;
`;

const MainBanner = styled.div`
  display: grid;
  align-content: center;
  justify-content: center;
  height: 200px;
  font-size: 26px;
  font-weight: bold;
`;

const MainContent = styled.div``;

export { MainGrid, MainContent, MainBanner };



// WEBPACK FOOTER //
// ./src/components/UI/MainUI.tsx